declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    mobile: true; // adds the `mobile` breakpoint
    tablet: true;
    laptop: true;
    desktop: true;
  }
}

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    light: true;
  }
}

declare module '@mui/material/styles' {
  interface Palette {
    third: Palette['primary'];
    fourth: Palette['primary'];
    fifth: Palette['primary'];
    sixth: Palette['primary'];
    seventh: Palette['primary'];
    eighth: Palette['primary'];
    ninth: Palette['primary'];
    tenth: Palette['primary'];
    transparent: Palette['primary'];
  }

  interface PaletteOptions {
    fourth?: PaletteOptions['primary'];
  }

  interface PaletteOptions {
    fifth?: PaletteOptions['primary'];
  }

  interface PaletteOptions {
    sixth?: PaletteOptions['primary'];
  }

  interface PaletteOptions {
    seventh?: PaletteOptions['primary'];
  }
  interface PaletteOptions {
    ninth?: PaletteOptions['primary'];
  }
  interface PaletteOptions {
    transparent?: PaletteOptions['primary'];
  }
}

export interface ThemeAdditional {
  fonts: IFonts;
}

export interface IFonts {
  families: IFamilies;
  sizes: ISizes;
  weights: IWeights;
}

export interface IFamilies {
  primary: string;
  secondary: string;
  calendar: string;
}

export interface ISizes {
  defaultS: number;
  default: number;
  defaultL: number;
  small: number;
  smallL: number;
  medium: number;
  mediumL: number;
  large: number;
  largeS: number;
  largeL: number;
  largeXL: number;
}
export interface IWeights {
  Thin: number;
  ExtraLigh: number;
  Light: number;
  Normal: number;
  Medium: number;
  SemiBold: number;
  Bold: number;
  ExtraBold: number;
  Black: number;
}

export enum IEBreakPoints {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  MOBILE = 'mobile',
  TABLET = 'tablet',
  LAPTOP = 'laptop',
  DESKTOP = 'desktop',
}
